// angular imports
import { 
    WritableSignal, 
    signal 
} from "@angular/core";

//local imports
import { ListItemFactory } from "@app/shared";
import { CategoryModel, DocumentModel, ProgramPropertyDto } from "@app/catalog";

export class ProgramPropertyModel 
{
    public id: string = "";    
    public name: WritableSignal<string>;
    public thumbnailUrl: WritableSignal<string>;
    public categories: WritableSignal<CategoryModel[]>;
    public documents: WritableSignal<DocumentModel[]>;
    public hasImageError: WritableSignal<boolean>;

    constructor()
    {
        this.name = signal<string>(null);
        this.thumbnailUrl = signal<string>(null);
        this.categories = signal<CategoryModel[]>([]);
        this.documents = signal<DocumentModel[]>([]);
        this.hasImageError = signal<boolean>(false);
    }

    public handleImageError() {
        this.hasImageError.set(true);
    }


    public static fromDto(dto: ProgramPropertyDto)
    {
        let program = new ProgramPropertyModel();

        program.id = dto.id;
        program.name.set(dto.name);
        program.thumbnailUrl.set(dto.thumbnailUrl);
        program.documents.set((dto.documents || []).map(doc => DocumentModel.fromDto(doc)));


        //TODO:DIW:At somepoint the selected categories could be passed in so CategoryModel.fromDto can have isChecked set properly.
        program.categories.set(dto.categories.map(cat=>CategoryModel.fromDto(cat, false)));        
        return program;
    }

    public toListItem = (selected: boolean = false) => 
        ListItemFactory.create<ProgramPropertyModel>(this.name, this.id, this, selected);
    

    public toListItem$ = (selected: WritableSignal<boolean>) =>
        ListItemFactory.create$<ProgramPropertyModel>(this.name, this.id, this, selected);

}
